export default {
  admin: '/admin/vessel-management',
  adminBanner: '/admin/banner',
  adminFeatureToggle: '/admin/feature-toggle',
  adminReleaseNotes: '/admin/release-notes',
  adminUserManagement: '/admin/user-management',
  deviceManagement: '/admin/device-management',
  fleet: '/fleet',
  fleetStatus: '/fleet-status',
  help: '/help',
  login: '/login',
  manual: '/manual',
  noModuleAccess: '/no-module-access',
  overview: '/',
  portCall: {
    comments: 'comments',
    gearboxLocations: 'gearbox-locations',
    productivity: 'productivity',
    shipOverview: 'ship-overview',
    summary: 'summary',
  },
  ports: {
    root: '/ports',
    showPort: 'showPort',
  },
  rob: '/rob',
  robSurvey: '/rob/survey',
  settings: '/settings',
  ship: {
    imoNumber: 'imoNumber',
    portCall: 'port-call',
    portCallId: 'portCallId',
    root: '/ship',
  },
  ssoFailed: '/sso-failed',
  viewReleaseNotes: '/release-notes',
  whatIsNew: '/what-is-new',
}
